module.exports = __webpack_public_path__ + "img/full-zoom-out.399e3073.svg";